//targetModels must be an array because of attacking multiple people. always assume its an array
import {getDescriptionObjectFromSubmission} from './get-description-object'
import {getRollout} from './get-rollout'
import {sendRolloutStepsToServer} from '../connection/firebase.js'
import store from '../../init/store.js'
import {getReplacedAction} from './get-replaced-action'
import makeId from '../../helpers/make-id.js'
import {handleNewRollout} from './handle-new-rollout'
import {createTurnReport, addReportToReportingHistory} from '../analysis/turn-reporting.js'

/** Create the result from this submission, then send along the cycle */
export function submitAction(actionModel, casterModel, rawTargetModels = []) {

  //Filter for only the targets that can be used (alive vs dead)
  const targetModels = rawTargetModels.filter(targetModel => {
    if (actionModel.targetMustBeDead) {
      //Only return DEAD
      return !targetModel.isAlive()
    } else {
      //Only return ALIVE

      if (actionModel.targetCanBeDead) {
        return true
      }

      return targetModel.isAlive()
    }
  });

  if (targetModels.length === 0) {
    console.warn('something is horribly wrong. targetModels is empty after `targetMustBeDead` check', casterModel.name, actionModel.name)
    //Action will auto fail
  }



  //Check if action needs replacing (EX: Caster has the 'lag' status)
  actionModel = getReplacedAction(actionModel, casterModel);

  //Get latest combatants
  const combatants = store.getState().battle.combatants;

  //Build a description object
  const descriptionObject = getDescriptionObjectFromSubmission(actionModel, casterModel, targetModels, combatants);

  //Use the description object to get a "Rollout" of human-readable words and state-changing instructions
  const rollout = getRollout(actionModel, casterModel, targetModels, descriptionObject);


  //SIDE EFFECT: REPORTING! (Does not affect battle) ///////////////////
    const turnReport = createTurnReport(rollout, descriptionObject, actionModel, casterModel, targetModels);
    if (!turnReport.actionId) {
      console.warn('turnReport created with no actionId', actionModel, casterModel)
    }
    addReportToReportingHistory(turnReport)
  ////////////////////////////////////////////


  //Submitting the action:
  //Case 1: Multiplayer!
  if (store.getState().battle.isMultiplayerMode) {

    // console.warn('rolloutSender is', store.getState().battle.combatantSelectingAction);
    // console.warn(store.getState().battle.seriesTurnOrder);
    // console.warn(store.getState().battle.seriesTurnsSubmitters);

    //Send to the server!
    sendRolloutStepsToServer(rollout, store.getState().battle.combatantSelectingAction);

  } else {

    //Case 2: Offline Play!
    //can go straight to handling this rollout, but need to format this as a model:
    const now = Date.now();

    // console.warn('rolloutSender is', store.getState().battle.combatantSelectingAction);
    // console.warn(store.getState().battle.seriesTurnOrder);
    // console.warn(store.getState().battle.seriesTurnsSubmitters);

    const rolloutUpdateModel = {
      submitterCombatantId: store.getState().battle.combatantSelectingAction,
      rolloutId: makeId("rollout", 10),
      timestamp: now,
      rolloutPayload: rollout
    };
    handleNewRollout(rolloutUpdateModel);

  }
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/submit-action.js